import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Printer, HardHat, Award } from "lucide-react";
import { api } from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";

const fmt = (d) => new Date(d).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });

export default function CertificatePage() {
  const { id } = useParams();
  const [c, setC] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get(`/certificates/${id}`).then((r) => setC(r.data)).catch(() => setErr(true)); }, [id]);
  if (err) return <p className="text-red-700 font-semibold" data-testid="certificate-error">Certificat introuvable.</p>;
  if (!c) return <Skeleton className="h-96 w-full" />;

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between print:hidden">
        <Link to="/profil" data-testid="certificate-back-btn" className="flex items-center gap-1 font-semibold text-slate-600 hover:text-slate-900">
          <ArrowLeft className="w-5 h-5" /> Profil
        </Link>
        <button onClick={() => window.print()} data-testid="certificate-print-btn" className="h-12 px-5 rounded-xl bg-orange-500 hover:bg-orange-600 text-white font-bold flex items-center gap-2 transition-colors">
          <Printer className="w-5 h-5" /> Imprimer
        </button>
      </div>

      <div className="certificate bg-white text-slate-900 border-[6px] border-slate-900 rounded-lg overflow-hidden" data-testid="certificate-sheet">
        <div className="hazard-stripe h-4" />
        <div className="p-6 sm:p-10 text-center space-y-5">
          <div className="flex items-center justify-center gap-2">
            <HardHat className="w-8 h-8 text-orange-500" />
            <span className="font-display text-2xl font-extrabold uppercase">Français Chantier</span>
          </div>
          <p className="font-display text-4xl sm:text-5xl font-extrabold uppercase tracking-wide">Certificat de progrès</p>
          <p className="text-base">Ce certificat atteste que</p>
          <p className="font-display text-4xl font-bold border-b-2 border-slate-900 inline-block px-6 pb-1" data-testid="certificate-name">{c.name}</p>
          <p className="text-base">{c.trade}</p>
          <p className="text-lg">
            a progressé en français professionnel du BTP du niveau <b>{c.level_from_label}</b> au niveau{" "}
            <b className="text-orange-600" data-testid="certificate-level">{c.level_to_label}</b>.
          </p>
          <div className="grid grid-cols-3 gap-3 max-w-md mx-auto">
            {[["Leçons", c.lessons, "certificate-lessons"], ["Mots appris", c.words, "certificate-words"], ["Réussite", `${c.average}%`, "certificate-average"]].map(([l, v, tid]) => (
              <div key={l} className="border-2 border-slate-300 rounded-lg py-2">
                <div className="font-display text-3xl font-bold" data-testid={tid}>{v}</div>
                <div className="text-xs font-bold uppercase">{l}</div>
              </div>
            ))}
          </div>
          <div className="flex items-end justify-between pt-6 text-left">
            <div className="text-sm">
              <div>Délivré le <b data-testid="certificate-date">{fmt(c.issued_at)}</b></div>
              <div className="text-xs text-slate-500">N° {c.code}</div>
              <div className="text-[11px] text-slate-500" data-testid="certificate-verify-url">Vérifier : {window.location.origin}/verifier/{c.code}</div>
            </div>
            <Award className="w-16 h-16 text-amber-500" />
            <div className="text-sm text-right">
              <div className="border-b border-slate-900 w-36 h-8" />
              <div className="text-xs">Visa de l'employeur</div>
            </div>
          </div>
        </div>
        <div className="hazard-stripe h-4" />
      </div>
    </div>
  );
}
